import React from 'react';
import {useBymoPageContextProps} from '../../doppe-sdk';
import {classes, style} from './doppe-page-privacy-and-terms-view.st.css';
import {useDoppeViewerLangDictionary} from '../doppe-viewer-lang-dictionary/doppe-viewer-lang-dictionary';

export const DoppePagePrivacyAndTermsView = React.memo(function DoppePagePrivacyAndTermsView(props: DoppePagePrivacyAndTermsView.Props) {
    const {
        className,
        ...htmlAttributes
    } = props;

    const bymoPageContextProps = useBymoPageContextProps();

    const {
        userDisplayName
    } = bymoPageContextProps;

    const userPrivacyPolicyUrl = (bymoPageContextProps.userPrivacyPolicyUrl ?? '').trim();
    const userTermsOfServiceUrl = (bymoPageContextProps.userTermsOfServiceUrl ?? '').trim();

    const doppeViewerLangDictionary = useDoppeViewerLangDictionary();

    if (userPrivacyPolicyUrl !== '' || userTermsOfServiceUrl !== '') {
        return (
            <div
                className={style(classes.root, className)}
                {...htmlAttributes}
            >
                {doppeViewerLangDictionary.termsOfServiceText}
                {
                    userTermsOfServiceUrl !== '' ?
                        <a href={userTermsOfServiceUrl} target={'_blank'} rel={'noopener'}>{doppeViewerLangDictionary.termsOfServiceLabel}</a> :
                        null
                }
                {userPrivacyPolicyUrl !== '' && userTermsOfServiceUrl !== '' ? ` ${doppeViewerLangDictionary.termsOfServiceTextAnd} ` : ''}
                {
                    userPrivacyPolicyUrl !== '' ?
                        <a href={userPrivacyPolicyUrl} target={'_blank'} rel={'noopener'}>{doppeViewerLangDictionary.termsOfServicePrivacyLabel}</a> :
                        null
                }
                {` ${doppeViewerLangDictionary.termsOfServiceTextOf} ${userDisplayName}`}
            </div>
        );
    } else {
        return null;
    }
});

export namespace DoppePagePrivacyAndTermsView {

    export interface Props extends React.HTMLAttributes<any> {

    }
}

